export default {
    addAndModifyRoleL:"/nova/relation/addAndModifyRole", //新增角色
    showRole:"/nova/relation/showRole",  //获取角色
    deleteRole:"/nova/relation/deleteRole", //删除角色
    getInvitation:"/nova/achievement/config/global/get/invitation", //获取直邀奖全局配置
    createInvitation:"/nova/achievement/config/global/create/invitation",    //创建直邀奖
    saveInvitation:"/nova/achievement/config/global/save/invitation",   //保存直邀奖
    getAgency:"/nova/achievement/config/global/get/agency",//获取管理奖
    createAgency:"/nova/achievement/config/global/create/agency", //创建管理奖
    saveAgency:"/nova/achievement/config/global/save/agency",    //保存管理奖
    getLevel:"/nova/achievement/config/global/get/level",    //获取平级奖
    createLevel:"/nova/achievement/config/global/create/level",  //创建平级将
    saveLevel:"/nova/achievement/config/global/save/level",  //保存平级奖
    getRepurchase:"/nova/achievement/config/global/get/repurchase",  //获取复购奖
    createRepurchase:"/nova/achievement/config/global/create/repurchase",    //创建复购将
    saveRepurchase:"/nova/achievement/config/global/save/repurchase",    //保存复购奖
    getTeam:"/nova/achievement/config/global/get/team",  //获取团队奖
    createTeam:"/nova/achievement/config/global/create/team",    //创建团队奖
    saveTeam:"/nova/achievement/config/global/save/team",    //保存团队奖
    showUpgradeRule:"/nova/relation/showUpgradeRule",   //升级规则列表
    addUpgradeRule:"/nova/relation/addUpgradeRule", //添加升级规则
    deleteUpgradeRule:"/nova/relation/deleteUpgradeRule",   //删除升级规则
    modifyUpgradeRule:"/nova/relation/modifyUpgradeRule",//修改升级规则
    saveSwitch:"/nova/achievement/config/global/save/switch",   //全局开关
    teamBase:"/nova/achievement/config/global/save/team/base",  //保存团队奖分拨配置
    achievementItemList: '/achievement/item/list',
    achievementItemRemoveNovaItem: '/achievement/item/removeNovaItem',
    achievementItemUpdateNovaWeight: '/achievement/item/updateNovaWeight',
    achievementItemSelectNovaItem: '/achievement/item/selectNovaItem',
    achievementItemNormalList: '/achievement/item/normal/list',
    selectAward: '/achievement/award/selectAward',
    addOrUpdateAward: '/achievement/award/addOrUpdateAward',
    selectAwardRoleLevel: '/achievement/award/selectAwardRoleLevel',
    createNovaStore: '/achievement/store/createNovaStore',
    deleteNovaStore: '/achievement/store/deleteNovaStore',
    showAllStore: '/achievement/store/showAllStore',
    showStoreAndAward: '/achievement/store/showStoreAndAward',
    updateStoreAward: '/achievement/storeAward/updateStoreAward',
    showStoreAward: '/achievement/storeAward/showStoreAward',
}